/*
 * <cdx-price-sort> – price sorting for large collections (wraps #ProductGridContainer in
 * sections/main-collection-product-grid.liquid). Shopify sorts by price only within the loaded page
 * set, so for "price-ascending/-descending" this loads a lightweight index of all products
 * (section cdx-price-sort-index, cached in sessionStorage), sorts it client-side and renders the cards
 * page by page (section cdx-price-sort-card, all cards of a page in one search request; products search
 * doesn't return are loaded one by one in the collection's context). Collections above MAX_PAGES index
 * pages fall back to native sorting (remembered per path in sessionStorage).
 * data-page-size = products per page, data-custom-badge = whether this collection shows the seal badge.
 */
(function () {
  if (window.customElements.get("cdx-price-sort")) return;

  var DEBUG = false;
  var INDEX_SECTION = "cdx-price-sort-index";
  var CARD_SECTION = "cdx-price-sort-card";
  var SORT_VALUES = ["price-ascending", "price-descending"];
  var MAX_PAGES = 40;
  var PAGE_SIZE = 24;
  var INDEX_CONCURRENCY = 4;
  var CARD_CONCURRENCY = 8;
  var SHOW_CUSTOM_BADGE = false;
  var INDEX_STORE_PREFIX = "cdxPriceSortIdx:v2:";
  var INDEX_TTL = 15 * 60 * 1000;

  var cache = {};
  var cardCache = {};
  var fetchToken = 0;
  var renderState = null;
  var idxLoaded = 0;
  var idxTotal = 0;
  var urgent = false;
  var progressPhase = null;

  var dbg = {
    status: "idle",
    pagesTotal: 0,
    pagesLoaded: 0,
    items: 0,
    cards: 0,
    timings: [],
    startedAt: 0,
    finishedAt: 0,
    sort: "-",
    log: []
  };
  var dbgEl = null;
  var dbgTimer = null;

  function dbgLog(msg) {
    if (!DEBUG) return;
    var time = new Date().toTimeString().slice(0, 8);
    dbg.log.unshift(time + " " + msg);
    if (dbg.log.length > 6) dbg.log.pop();
    dbgRender();
  }

  function dbgSet(patch) {
    if (!DEBUG) return;
    for (var k in patch) dbg[k] = patch[k];
    dbgRender();
  }

  function dbgRender() {
    if (!DEBUG) return;
    if (!dbgEl) {
      dbgEl = document.createElement("div");
      dbgEl.id = "cdx-price-sort-debug";
      dbgEl.style.cssText =
        "position:fixed;bottom:12px;right:12px;z-index:99999;background:rgba(15,15,15,.94);color:#00ff88;font:11px/1.5 monospace;padding:10px 12px;border:1px solid #333;border-radius:6px;min-width:260px;max-width:320px;pointer-events:none;white-space:pre-wrap;";
      document.body.appendChild(dbgEl);
    }
    var avg = 0;
    var last = 0;
    if (dbg.timings.length) {
      last = dbg.timings[dbg.timings.length - 1];
      var sum = 0;
      for (var i = 0; i < dbg.timings.length; i++) sum += dbg.timings[i];
      avg = Math.round(sum / dbg.timings.length);
    }
    var elapsed = 0;
    if (dbg.startedAt) {
      elapsed = Math.round(((dbg.finishedAt || Date.now()) - dbg.startedAt) / 100) / 10;
    }
    var barLen = 20;
    var ratio = dbg.pagesTotal ? dbg.pagesLoaded / dbg.pagesTotal : 0;
    var filled = Math.round(ratio * barLen);
    var bar = "";
    for (var b = 0; b < barLen; b++) bar += b < filled ? "\u2588" : "\u2591";
    var lines = [
      "CDX PRICE SORT DEBUG",
      "Status:   " + dbg.status,
      "Index:    " + dbg.pagesLoaded + "/" + (dbg.pagesTotal || "?") + " Seiten",
      bar + " " + Math.round(ratio * 100) + "%",
      "Produkte: " + dbg.items,
      "Karten:   " + dbg.cards + " geladen",
      "Zeit:     " + elapsed + "s gesamt | " + last + "ms letzte | \u00d8 " + avg + "ms",
      "Sort:     " + dbg.sort,
      "\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500\u2500"
    ].concat(dbg.log);
    dbgEl.textContent = lines.join("\n");
  }

  function dbgTick(on) {
    if (!DEBUG) return;
    if (on && !dbgTimer) {
      dbgTimer = setInterval(dbgRender, 500);
    } else if (!on && dbgTimer) {
      clearInterval(dbgTimer);
      dbgTimer = null;
      dbgRender();
    }
  }

  function skipKey() {
    return "cdxPriceSortSkipV2:" + window.location.pathname;
  }

  function isSkipped() {
    try {
      return sessionStorage.getItem(skipKey()) === "1";
    } catch (e) {
      return false;
    }
  }

  function setSkipped() {
    try {
      sessionStorage.setItem(skipKey(), "1");
    } catch (e) {}
  }

  function idxLoad(key) {
    try {
      var raw = sessionStorage.getItem(INDEX_STORE_PREFIX + key);
      if (!raw) return null;
      var data = JSON.parse(raw);
      if (!data || !data.items || Date.now() - data.t > INDEX_TTL) {
        sessionStorage.removeItem(INDEX_STORE_PREFIX + key);
        return null;
      }
      return data;
    } catch (e) {
      return null;
    }
  }

  function idxSave(key, items, pages) {
    try {
      sessionStorage.setItem(
        INDEX_STORE_PREFIX + key,
        JSON.stringify({ t: Date.now(), pages: pages, items: items })
      );
    } catch (e) {}
  }

  function currentSort() {
    return new URLSearchParams(window.location.search).get("sort_by");
  }

  function currentPageParam() {
    var page = parseInt(new URLSearchParams(window.location.search).get("page"), 10);
    return page > 0 ? page : 1;
  }

  function isPriceSort(value) {
    return SORT_VALUES.indexOf(value) !== -1;
  }

  function cacheKey(params) {
    var p = new URLSearchParams(params);
    p.delete("sort_by");
    p.delete("page");
    p.delete("section_id");
    p.sort();
    return window.location.pathname + "|" + p.toString();
  }

  function indexUrl(params, page) {
    var p = new URLSearchParams(params);
    p.delete("sort_by");
    p.set("section_id", INDEX_SECTION);
    p.set("page", page);
    return window.location.pathname + "?" + p.toString();
  }

  function cardsSearchUrl(ids) {
    var query = ids
      .map(function (id) {
        return "id:" + id;
      })
      .join(" OR ");
    var base = (window.routes && window.routes.search_url) || "/search";
    return base + "?type=product&section_id=" + CARD_SECTION + "&q=" + encodeURIComponent(query);
  }

  // Single card in the collection's context (fallback for products the search doesn't return)
  function cardUrl(handle) {
    return window.location.pathname.replace(/\/$/, "") + "/products/" + handle + "?section_id=" + CARD_SECTION;
  }

  function getContainer() {
    return document.getElementById("ProductGridContainer");
  }

  function getGrid() {
    return document.getElementById("product-grid");
  }

  function setLoading(on) {
    var container = getContainer();
    if (!container) return;
    var collection = container.querySelector(".collection");
    if (collection) collection.classList.toggle("loading", on);
  }

  function showProgress(phase) {
    progressPhase = phase;
    updateProgressUI();
  }

  function hideProgress() {
    progressPhase = null;
    var el = document.getElementById("cdx-price-sort-progress");
    if (el) el.remove();
  }

  function updateProgressUI() {
    if (!progressPhase) return;
    var container = getContainer();
    if (!container) return;
    var el = document.getElementById("cdx-price-sort-progress");
    if (!el) {
      el = document.createElement("div");
      el.id = "cdx-price-sort-progress";
      el.className = "cdx-price-sort-progress";
      var logo = document.createElement("img");
      logo.src = "https://www.klimaworld.com/cdn/shop/files/KlimaWorld_logo_std_rgb_194bde54-952e-473d-b2ac-b872551c41f6.svg?v=1737895722&width=200";
      logo.alt = "Klimaworld";
      logo.className = "cdx-price-sort-progress-logo";
      logo.width = 180;
      logo.height = 43;
      var text = document.createElement("p");
      text.className = "cdx-price-sort-progress-text";
      text.textContent = "Produkte werden sortiert\u2026";
      var track = document.createElement("div");
      track.className = "cdx-price-sort-progress-track";
      var fill = document.createElement("div");
      fill.className = "cdx-price-sort-progress-fill indeterminate";
      track.appendChild(fill);
      el.appendChild(logo);
      el.appendChild(text);
      el.appendChild(track);
      var collection = container.querySelector(".collection");
      if (collection) {
        collection.appendChild(el);
      } else {
        container.insertBefore(el, container.firstChild);
      }
    }
  }

  function markActive(on) {
    var container = getContainer();
    if (!container) return;
    container.classList.toggle("cdx-price-sort-active", on);
    if (!on) {
      removePagers();
      renderState = null;
    }
  }

  function parseIndex(html) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var el = doc.getElementById(INDEX_SECTION);
    if (!el) return null;
    var items;
    try {
      items = JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
    return {
      pages: parseInt(el.getAttribute("data-pages"), 10) || 1,
      items: items
    };
  }

  function fetchIndexPage(params, page) {
    var t0 = Date.now();
    return fetch(indexUrl(params, page), { priority: urgent ? "auto" : "low" }).then(function (response) {
      if (!response.ok) throw new Error("index fetch failed");
      return response.text().then(function (text) {
        idxLoaded += 1;
        updateProgressUI();
        if (DEBUG) {
          dbg.timings.push(Date.now() - t0);
          dbg.pagesLoaded += 1;
          dbgLog("Index " + page + " geladen (" + (Date.now() - t0) + "ms)");
        }
        return text;
      });
    });
  }

  function loadIndex(params) {
    var key = cacheKey(params);
    if (cache[key]) return cache[key].promise;
    var stored = idxLoad(key);
    if (stored) {
      var hydrated = { ready: true, items: stored.items, promise: Promise.resolve(stored.items) };
      cache[key] = hydrated;
      dbgSet({ status: "Index aus Session-Cache", items: stored.items.length, pagesLoaded: stored.pages, pagesTotal: stored.pages, startedAt: 0, finishedAt: 0 });
      dbgLog("Index aus sessionStorage (" + stored.items.length + " Produkte)");
      return hydrated.promise;
    }
    var entry = { ready: false, items: null };
    cache[key] = entry;
    var totalPagesSeen = 1;
    idxLoaded = 0;
    idxTotal = 0;
    dbgSet({ status: "Index l\u00e4dt", pagesLoaded: 0, pagesTotal: 0, timings: [], startedAt: Date.now(), finishedAt: 0 });
    dbgTick(true);
    entry.promise = fetchIndexPage(params, 1)
      .then(function (html) {
        var first = parseIndex(html);
        if (!first) throw new Error("index section missing");
        totalPagesSeen = first.pages;
        idxTotal = first.pages;
        updateProgressUI();
        dbgSet({ pagesTotal: first.pages, items: first.items.length });
        if (first.pages > MAX_PAGES) {
          var err = new Error("too many pages");
          err.tooLarge = true;
          throw err;
        }
        if (first.pages <= 1) return first.items;
        var pages = [];
        for (var i = 2; i <= first.pages; i++) pages.push(i);
        var collected = first.items;
        function runBatch() {
          if (!pages.length) return Promise.resolve(collected);
          var batch = pages.splice(0, urgent ? 8 : INDEX_CONCURRENCY);
          return Promise.all(
            batch.map(function (page) {
              return fetchIndexPage(params, page);
            })
          ).then(function (htmls) {
            for (var j = 0; j < htmls.length; j++) {
              var feed = parseIndex(htmls[j]);
              if (feed) collected = collected.concat(feed.items);
            }
            dbgSet({ items: collected.length });
            return runBatch();
          });
        }
        return runBatch();
      })
      .then(function (items) {
        entry.items = items;
        entry.ready = true;
        idxSave(key, items, totalPagesSeen);
        dbgSet({ status: "Index bereit", items: items.length, finishedAt: Date.now() });
        dbgTick(false);
        dbgLog("Index fertig: " + items.length + " Produkte");
        return items;
      })
      .catch(function (err) {
        delete cache[key];
        dbgSet({ status: err && err.tooLarge ? "zu gro\u00df \u2192 nativ" : "Fehler: " + err.message, finishedAt: Date.now() });
        dbgTick(false);
        dbgLog(err && err.tooLarge ? "Cap \u00fcberschritten (" + dbg.pagesTotal + " Seiten)" : "Fehler: " + err.message);
        throw err;
      });
    return entry.promise;
  }

  function cardMarkup(wrap) {
    if (!SHOW_CUSTOM_BADGE) {
      wrap.querySelectorAll("[data-custom-badge]").forEach(function (badge) {
        badge.remove();
      });
    }
    return wrap.innerHTML;
  }

  function fetchCard(handle) {
    return fetch(cardUrl(handle))
      .then(function (response) {
        if (!response.ok) throw new Error("card fetch failed");
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var wrap = doc.querySelector("[data-cdx-card]");
        if (!wrap) throw new Error("card markup missing");
        return wrap.innerHTML;
      });
  }

  // Loads the cards of the given index items (one search request), keyed by handle
  function ensureCards(items) {
    var results = {};
    var missing = items.filter(function (item) {
      if (cardCache[item.h]) {
        results[item.h] = cardCache[item.h];
        return false;
      }
      return true;
    });
    if (!missing.length) return Promise.resolve(results);

    return fetch(cardsSearchUrl(missing.map(function (item) { return item.i; })))
      .then(function (response) {
        if (!response.ok) throw new Error("cards fetch failed");
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var byId = {};
        doc.querySelectorAll("[data-cdx-card]").forEach(function (wrap) {
          byId[wrap.dataset.productId] = cardMarkup(wrap);
        });
        return byId;
      })
      .catch(function () {
        return {};
      })
      .then(function (byId) {
        var fallback = [];
        missing.forEach(function (item) {
          var markup = byId[String(item.i)];
          if (markup) {
            cardCache[item.h] = markup;
            results[item.h] = markup;
          } else {
            fallback.push(item);
          }
        });
        if (DEBUG) {
          dbg.cards += missing.length;
          dbgRender();
        }
        return runFallback(fallback);
      })
      .then(function () {
        return results;
      });

    function runFallback(queue) {
      if (!queue.length) return Promise.resolve();
      var batch = queue.splice(0, CARD_CONCURRENCY);
      return Promise.all(
        batch.map(function (item) {
          return fetchCard(item.h)
            .then(function (markup) {
              cardCache[item.h] = markup;
              results[item.h] = markup;
            })
            .catch(function () {
              results[item.h] = null;
            });
        })
      ).then(function () {
        return runFallback(queue);
      });
    }
  }

  function buildChunk(items, from, to, cards) {
    var frag = document.createDocumentFragment();
    for (var i = from; i < to && i < items.length; i++) {
      var html = cards[items[i].h];
      if (!html) continue;
      var li = document.createElement("li");
      li.className = "grid-item";
      li.innerHTML = html;
      frag.appendChild(li);
    }
    return frag;
  }

  function chunkItems(items, from, to) {
    return items.slice(from, Math.min(to, items.length));
  }

  function totalPages() {
    if (!renderState) return 1;
    return Math.max(1, Math.ceil(renderState.sorted.length / PAGE_SIZE));
  }

  function setPageParam(page) {
    var p = new URLSearchParams(window.location.search);
    if (page > 1) {
      p.set("page", page);
    } else {
      p.delete("page");
    }
    var qs = p.toString();
    history.replaceState(
      { searchParams: qs },
      "",
      window.location.pathname + (qs ? "?" + qs : "")
    );
  }

  function getPagers() {
    return document.querySelectorAll(".cdx-price-sort-pager");
  }

  function removePagers() {
    var pagers = getPagers();
    for (var i = 0; i < pagers.length; i++) pagers[i].remove();
  }

  function buildPager() {
    var pager = document.createElement("div");
    pager.className = "pagination-custom pagination-bottom cdx-price-sort-pager";

    var prev = document.createElement("a");
    prev.href = "#";
    prev.setAttribute("aria-label", "Vorherige Seite");
    prev.dataset.dir = "-1";
    prev.innerHTML = "&#10094;";

    var label = document.createElement("span");
    label.textContent = "Seite:";

    var input = document.createElement("input");
    input.type = "number";
    input.className = "pagination-input";
    input.min = "1";

    var total = document.createElement("span");
    total.dataset.total = "1";

    var next = document.createElement("a");
    next.href = "#";
    next.setAttribute("aria-label", "N\u00e4chste Seite");
    next.dataset.dir = "1";
    next.innerHTML = "&#10095;";

    pager.appendChild(prev);
    pager.appendChild(label);
    pager.appendChild(input);
    pager.appendChild(total);
    pager.appendChild(next);

    pager.addEventListener("click", function (event) {
      var link = event.target.closest("a[data-dir]");
      if (!link) return;
      event.preventDefault();
      if (!renderState) return;
      goToPage(renderState.page + parseInt(link.dataset.dir, 10));
    });

    input.addEventListener("keydown", function (event) {
      if (event.key !== "Enter") return;
      event.preventDefault();
      var page = parseInt(input.value, 10);
      if (page >= 1 && page <= totalPages()) {
        goToPage(page);
      } else if (renderState) {
        input.value = renderState.page;
      }
    });

    return pager;
  }

  function updatePager() {
    if (!renderState) return;
    var pages = totalPages();
    if (pages <= 1) {
      removePagers();
      return;
    }
    var container = getContainer();
    if (!container) return;

    var secondary = container.querySelector(".collection-actions-secondary");
    if (secondary && !secondary.querySelector(".cdx-price-sort-pager")) {
      secondary.insertBefore(buildPager(), secondary.firstChild);
    }

    var collection = container.querySelector(".collection");
    if (collection) {
      var afterCollection = collection.nextElementSibling;
      var hasBottom = afterCollection && afterCollection.classList && afterCollection.classList.contains("cdx-price-sort-pager");
      if (!hasBottom) {
        collection.parentNode.insertBefore(buildPager(), collection.nextSibling);
      }
    }

    var pagers = getPagers();
    for (var i = 0; i < pagers.length; i++) {
      var inputEl = pagers[i].querySelector("input");
      var totalEl = pagers[i].querySelector("span[data-total]");
      var prevEl = pagers[i].querySelector("a[data-dir='-1']");
      var nextEl = pagers[i].querySelector("a[data-dir='1']");
      inputEl.value = renderState.page;
      inputEl.max = pages;
      totalEl.textContent = "/ " + pages;
      prevEl.style.visibility = renderState.page > 1 ? "visible" : "hidden";
      nextEl.style.visibility = renderState.page < pages ? "visible" : "hidden";
    }
  }

  function goToPage(page) {
    if (!renderState || renderState.loadingPage) return;
    var state = renderState;
    var pages = totalPages();
    page = Math.min(Math.max(1, page), pages);
    if (page === state.page) return;
    var grid = getGrid();
    if (!grid) return;
    var from = (page - 1) * PAGE_SIZE;
    var to = Math.min(from + PAGE_SIZE, state.sorted.length);
    state.loadingPage = true;
    var pagers = getPagers();
    for (var i = 0; i < pagers.length; i++) pagers[i].classList.add("is-loading");
    setLoading(true);
    var t0 = Date.now();
    ensureCards(chunkItems(state.sorted, from, to)).then(function (cards) {
      if (renderState !== state) return;
      grid.innerHTML = "";
      grid.appendChild(buildChunk(state.sorted, from, to, cards));
      state.page = page;
      state.loadingPage = false;
      var donePagers = getPagers();
      for (var i = 0; i < donePagers.length; i++) donePagers[i].classList.remove("is-loading");
      setLoading(false);
      setPageParam(page);
      updatePager();
      var main = document.getElementById("MainContent");
      if (main) main.scrollIntoView(true);
      dbgLog("Seite " + page + "/" + totalPages() + " gerendert (" + (Date.now() - t0) + "ms)");
    });
  }

  function renderSorted(items, direction, token, startPage) {
    var grid = getGrid();
    if (!grid) return Promise.resolve();
    var sorted = items.slice().sort(function (a, b) {
      if (a.n !== b.n) return a.n ? 1 : -1;
      if (direction === "price-descending") return b.p - a.p;
      return a.p - b.p;
    });
    var pages = Math.max(1, Math.ceil(sorted.length / PAGE_SIZE));
    var page = Math.min(Math.max(1, startPage || 1), pages);
    var from = (page - 1) * PAGE_SIZE;
    var to = Math.min(from + PAGE_SIZE, sorted.length);
    var t0 = Date.now();
    return ensureCards(chunkItems(sorted, from, to)).then(function (cards) {
      if (token !== fetchToken) return;
      renderState = { sorted: sorted, page: page, loadingPage: false };
      grid.innerHTML = "";
      grid.appendChild(buildChunk(sorted, from, to, cards));
      markActive(true);
      setPageParam(page);
      updatePager();
      dbgSet({ sort: direction });
      dbgLog("Sortiert, Seite " + page + "/" + pages + " in " + (Date.now() - t0) + "ms");
    });
  }

  function applySort(direction, params, allowRedirect, startPage) {
    var token = ++fetchToken;
    var key = cacheKey(params);
    var entry = cache[key];
    var indexPending = !entry || !entry.ready;
    if (indexPending) {
      setLoading(true);
      urgent = true;
      showProgress("index");
    }
    dbgLog("Sort angefordert: " + direction + (indexPending ? " (l\u00e4dt)" : " (Cache)"));
    loadIndex(params)
      .then(function (items) {
        if (token !== fetchToken) return;
        urgent = false;
        setLoading(true);
        if (indexPending) showProgress("cards");
        return renderSorted(items, direction, token, startPage).then(function () {
          setLoading(false);
          hideProgress();
        });
      })
      .catch(function (err) {
        if (token !== fetchToken) return;
        urgent = false;
        setLoading(false);
        hideProgress();
        markActive(false);
        if (err && err.tooLarge) {
          setSkipped();
          if (allowRedirect) {
            window.location.assign(
              window.location.pathname + (params ? "?" + params : "")
            );
          }
        }
      });
  }

  function formParams() {
    var form = document.getElementById("FacetsFilterForm");
    if (!form) return window.location.search.slice(1);
    return new URLSearchParams(new FormData(form)).toString();
  }

  function preload() {
    if (isSkipped()) return;
    if (!document.getElementById("collection-sort-order")) return;
    dbgLog("Index-Preload startet");
    loadIndex(window.location.search.slice(1)).catch(function (err) {
      if (err && err.tooLarge) setSkipped();
    });
  }

  // Load the price index only when someone is about to sort: pointer over / focus / touch on the sort
  // select (it can be re-rendered by the filters, hence delegated). Sorting without that still works,
  // the index is then loaded on the change itself.
  function schedulePreload(signal) {
    var intent = new AbortController();
    signal.addEventListener("abort", function () {
      intent.abort();
    });
    function onIntent(event) {
      var target = event.target;
      if (!target || !target.closest || !target.closest("#collection-sort-order, [for='collection-sort-order']")) return;
      intent.abort();
      preload();
    }
    ["pointerover", "focusin", "touchstart"].forEach(function (type) {
      document.addEventListener(type, onIntent, { passive: true, signal: intent.signal });
    });
  }

  function onSortInput(event) {
    var target = event.target;
    if (!target || target.id !== "collection-sort-order") return;
    if (isSkipped()) return;
    if (!isPriceSort(target.value)) {
      markActive(false);
      return;
    }
    event.stopPropagation();
    var params = formParams();
    history.pushState(
      { searchParams: params },
      "",
      window.location.pathname + (params ? "?" + params : "")
    );
    applySort(target.value, params, true, 1);
  }

  // Facet filtering re-renders the grid: re-apply the price sort to the new results
  function observeContainer() {
    var container = getContainer();
    if (!container) return null;
    var observer = new MutationObserver(function () {
      if (isSkipped()) return;
      var sort = currentSort();
      if (isPriceSort(sort)) {
        applySort(sort, window.location.search.slice(1), false, currentPageParam());
      } else {
        markActive(false);
      }
    });
    observer.observe(container, { childList: true });
    return observer;
  }

  customElements.define(
    "cdx-price-sort",
    class CdxPriceSort extends HTMLElement {
      connectedCallback() {
        PAGE_SIZE = parseInt(this.dataset.pageSize, 10) || PAGE_SIZE;
        SHOW_CUSTOM_BADGE = this.dataset.customBadge === "true";
        this.abortController = new AbortController();
        // Capture on the host: runs before <facet-filters-form> reacts to the sort change
        this.addEventListener("input", onSortInput, { capture: true, signal: this.abortController.signal });

        if (isSkipped()) {
          if (DEBUG) {
            dbgSet({ status: "skip-flag aktiv (nativ)" });
            dbgLog("Collection als zu groß markiert");
          }
          return;
        }
        this.observer = observeContainer();
        schedulePreload(this.abortController.signal);
        var sort = currentSort();
        if (isPriceSort(sort)) {
          applySort(sort, window.location.search.slice(1), false, currentPageParam());
        }
      }

      disconnectedCallback() {
        if (this.abortController) this.abortController.abort();
        if (this.observer) this.observer.disconnect();
        // Ignore responses of requests that are still running
        fetchToken += 1;
      }
    }
  );
})();
